/* RPA 3D – boucle fluide : fondu enchaîné entre la fin et le début des vidéos en boucle.
   Les vidéos ne se téléchargent que lorsqu'elles arrivent près de l'écran.
   Usage : <div data-xloop> … <video> … </div> (la vidéo doit être en position absolue dans son conteneur). */
(function(){
  if(window.__rpaXloop) return; window.__rpaXloop=true;
  var FADE=1.1;
  function prep(x){ x.muted=true; x.defaultMuted=true; x.loop=false; x.playsInline=true; x.setAttribute('playsinline',''); x.setAttribute('muted',''); x.removeAttribute('autoplay'); x.autoplay=false; x.style.transition='opacity '+FADE+'s linear'; }
  function setup(box){
    var v=box.querySelector('video'); if(!v||v.dataset.xl) return;
    v.dataset.xl='1'; prep(v);
    var c=v.cloneNode(true); c.dataset.xl='1'; c.setAttribute('aria-hidden','true'); c.preload='none';
    prep(c); c.style.opacity='0'; c.style.zIndex='1'; v.style.zIndex='2'; v.style.opacity='1';
    v.parentNode.insertBefore(c,v.nextSibling);
    var a=v, b=c, busy=false, on=false, seen=false, raf=0;
    function play(x){ var p=x.play(); if(p&&p.catch) p.catch(function(){}); }
    function swap(){
      if(busy) return; busy=true;
      b.currentTime=0; play(b);
      b.style.zIndex='3'; a.style.zIndex='2';
      requestAnimationFrame(function(){ b.style.opacity='1'; });
      setTimeout(function(){ a.pause(); a.style.opacity='0'; a.style.zIndex='1'; var t=a; a=b; b=t; busy=false; }, FADE*1000+80);
    }
    function tick(){
      if(!on) return;
      if(a.duration && isFinite(a.duration) && a.duration>FADE*2.5 && a.currentTime>=a.duration-FADE) swap();
      raf=requestAnimationFrame(tick);
    }
    a.addEventListener('ended',function(){ if(!busy) swap(); });
    c.addEventListener('ended',function(){ if(!busy) swap(); });
    function start(){ if(on||document.hidden) return; on=true; if(a.preload!=='auto') a.preload='auto'; play(a); setTimeout(function(){ if(on&&b.preload!=='auto'){ b.preload='auto'; try{ b.load(); }catch(e){} } },1500); raf=requestAnimationFrame(tick); }
    function stop(){ on=false; cancelAnimationFrame(raf); a.pause(); b.pause(); }
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es){ seen=es[0].isIntersecting; seen?start():stop(); },{rootMargin:'300px 0px'}).observe(box);
    } else { seen=true; start(); }
    document.addEventListener('visibilitychange',function(){ if(document.hidden) stop(); else if(seen) start(); });
  }
  function boot(root){ [].forEach.call((root||document).querySelectorAll('[data-xloop]'),setup); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){boot();}); else boot();
  document.addEventListener('shopify:section:load',function(e){ boot(e.target); });
  window.rpaXloop=boot;
})();